import { render } from "./BeneficiaryHistory.vue?vue&type=template&id=1c3b09d8&scoped=true"
import script from "./BeneficiaryHistory.vue?vue&type=script&lang=js"
export * from "./BeneficiaryHistory.vue?vue&type=script&lang=js"

import "./BeneficiaryHistory.vue?vue&type=style&index=0&id=1c3b09d8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3b09d8"]])

export default __exports__